/******** priceView.js ********/
// .forEach fix for ie11
if (window.NodeList && !NodeList.prototype.forEach) {
  (<any>NodeList.prototype.forEach) = Array.prototype.forEach;
}
class PriceView implements PriceViewInterface {
  OCForm1: HTMLFormElement;
  priceViewCookieName: string;
  currentPageName: string;
  cashViewPages: string[];
  pointsViewPages: string[];
  toggleElements: ToggleElements;
  pointsLogin: PointsLogin;
  enablePayByPoints: boolean;
  propsDisablePoints: PropsDisablePoints;
  pointsUnvailLightbox: DialogObj;
  currentView: string;
  displayATC: boolean;

  constructor({
    priceViewCookieName,
    currentPageName,
    cashViewPages,
    pointsViewPages,
    toggleElements,
    pointsLogin,
    enablePayByPoints,
    propsDisablePoints,
    pointsUnvailLightbox
  }) {
    this.OCForm1 = document.querySelector('#OCForm1');
    this.priceViewCookieName = priceViewCookieName;
    this.currentPageName = currentPageName;
    this.cashViewPages = cashViewPages;
    this.pointsViewPages = pointsViewPages;
    this.toggleElements = toggleElements;
    this.currentView = 'cash';
    this.pointsLogin = pointsLogin;
    this.enablePayByPoints = enablePayByPoints;
    this.propsDisablePoints = propsDisablePoints;
    this.pointsUnvailLightbox = pointsUnvailLightbox;
    this.displayATC=true;
  }
  updateHasSubValue(value: boolean): void {
    this.propsDisablePoints['hasSubInCart'] = value;
  }
  bindElementHandlers(): void {
    const cashTabs = document.querySelectorAll(`.${this.toggleElements.cashTabClass}`);
    if (cashTabs){
      cashTabs.forEach((element) => {
        element.addEventListener('click', () => {
          this.togglePriceView('cash');
        });
      });
    }
    const pointsTabs = document.querySelectorAll(`.${this.toggleElements.pointsTabClass}`);
    if (pointsTabs){
      pointsTabs.forEach((element) => {
        element.addEventListener('click', () => {
          this.togglePriceView('points');
        });
      });
    }
    const switchers = this.OCForm1.elements[this.toggleElements.checkboxName];
    if (switchers) {
      if (switchers.length !== undefined) {
        for (let i = 0; i < switchers.length; i++) {
          switchers[i].addEventListener('click', () => {
            if (switchers[i].checked === false) { switchers[i].checked = true; } else { switchers[i].checked = false; }
          });
        }
      } else {
        switchers.addEventListener('click', () => {
          if (switchers.checked === false) { switchers.checked = true; } else { switchers.checked = false; }
        });
      }
    }
    const pointsLoginBtn=$(this.pointsLogin.btn_login_points);
    if (pointsLoginBtn.length){
      $(pointsLoginBtn).on('click', () => {
        if (this.enablePayByPoints) {
          let thisPage=`${encodeURIComponent(window.location.pathname.replace('/',''))}${encodeURIComponent(window.location.search)}`;
          thisPage=(thisPage==='')?'index.aspx':thisPage;
          setCookie('returnPage',thisPage);
          window.location.href=this.pointsLogin.url;
        } else {          
          dilogBox(this.pointsUnvailLightbox);
        }
      });
    }
    const pointsLogoutBtn=$(this.pointsLogin.btn_logout_points);
    if (pointsLogoutBtn.length){
      $(pointsLogoutBtn).on('click', () => {
        const ajaxURL = 'ajax/points.aspx';
        const ajaxParams = 'posting=TRUE&actionType=LOGOUTPOINTS';
        $.ajax({
          url: ajaxURL,
          type: 'POST',
          cache: false,
          data: ajaxParams,
          async: true,
          complete: () => {
            sessionStorage.clear();
            window.location.reload();
          }
        });
      });      
    }
    const btn_cart_checkout=$(this.propsDisablePoints.cartCheckoutBtnID);
    if (btn_cart_checkout.length){
      $(btn_cart_checkout).on('click', () => {
        window.location.href='checkout.aspx';
      });
    }
  }
  onLoadCheckPriceView(): void {
    const cookieValue = getCookie(this.priceViewCookieName);
    if (cookieValue === 'points'){
      const cashViewPagesFound=this.cashViewPages.find(page=>page===this.currentPageName);
      if (cashViewPagesFound!==undefined) {
        this.currentView = 'points';
        this.togglePriceView('cash');
      } else {
        this.togglePriceView('points');
      }
    } else {
      const pointsViewPagesFound=this.pointsViewPages.find(page=>page===this.currentPageName);
      if (pointsViewPagesFound!==undefined) {
        this.togglePriceView('points');
      }
    }
  }
  togglePriceView(toggledView: string): void {
    if (this.currentView !== toggledView) {
      setCookie(this.priceViewCookieName, toggledView);
      const details = document.querySelectorAll(`.${this.toggleElements.toggleClass}`);
      const switchers2 = this.OCForm1.elements[this.toggleElements.checkboxName];
      this.currentView = toggledView;
      const subsContainer: HTMLElement = document.querySelector(this.toggleElements.subsContainer);
      const subsMsgContainer: HTMLElement = document.querySelector(this.toggleElements.subsMsgContainer);
      const oneTimePurcContainer: HTMLElement = document.querySelector(this.toggleElements.oneTimePurcContainer);
      const btn_cart_checkout: HTMLElement = document.querySelector(this.propsDisablePoints.cartCheckoutBtnID);
      const cashTabs = document.querySelectorAll(`.${this.toggleElements.cashTabClass}`);
      const pointsTabs = document.querySelectorAll(`.${this.toggleElements.pointsTabClass}`);
      const currentFocusTab : HTMLElement = document.activeElement as HTMLElement;
      if (toggledView === 'cash') {
        cashTabs.forEach((element) => {
          element.setAttribute('aria-selected', 'true');
          element.removeAttribute('tabindex');
        });
        pointsTabs.forEach((element) => {
          element.setAttribute('aria-selected', 'false');
          element.setAttribute('tabindex', "-1");
        });
        details.forEach((element) => {
          element.classList.remove(this.toggleElements.toggleClassPoints);
        });
        if (switchers2) {
          if (switchers2.length !== undefined) {
            for (let i = 0; i < switchers2.length; i++) {
              switchers2[i].checked = false;
            }
          } else {
            switchers2.checked = false;
          }
        }
        if (subsContainer) {
          subsContainer.style.display = 'block';
          subsMsgContainer.style.display = 'none';
        }
        if (btn_cart_checkout&&this.propsDisablePoints.hasSubInCart){
          $(btn_cart_checkout).prop('disabled', false);
          $(btn_cart_checkout).removeClass('disabled');
          $(btn_cart_checkout).parent().removeClass('disabled-wrapper');
        }
        [this.propsDisablePoints.atcPointsUnavailNote,this.propsDisablePoints.lbPointsUnavailNote].forEach((id)=>{hideElement(id);});
        [this.propsDisablePoints.div_lbCartBtns, this.propsDisablePoints.cartCheckoutBtnID].forEach((id) => { showElement(id); });
        if (this.displayATC) { showElement(this.propsDisablePoints.addToCartBtn)} else { hideElement(this.propsDisablePoints.addToCartBtn); }
        this.verifySubInCart();
      } else {
        pointsTabs.forEach((element) => {
          element.setAttribute('aria-selected', 'true');
          element.removeAttribute('tabindex');
        });
        cashTabs.forEach((element) => {
          element.setAttribute('aria-selected', 'false');
          element.setAttribute('tabindex', "-1");
        });
        details.forEach((element) => {
          element.classList.add(this.toggleElements.toggleClassPoints);
        });
        if (switchers2) {
          if (switchers2.length !== undefined) {
            for (let i = 0; i < switchers2.length; i++) {
              switchers2[i].checked = true;
            }
          } else {
            switchers2.checked = true;
          }
        }
        if (subsContainer) {
          subsContainer.style.display = 'none';
          oneTimePurcContainer.click();
          currentFocusTab.focus();
          subsMsgContainer.style.display = 'block';
        }
        if (btn_cart_checkout&&this.propsDisablePoints.hasSubInCart){
            $(btn_cart_checkout).prop('disabled', true);
            $(btn_cart_checkout).addClass('disabled');
            $(btn_cart_checkout).parent().addClass('disabled-wrapper');
        }
        if (!this.enablePayByPoints){
          [this.propsDisablePoints.atcPointsUnavailNote,this.propsDisablePoints.lbPointsUnavailNote].forEach((id)=>{showElement(id);});
          [this.propsDisablePoints.div_lbCartBtns,this.propsDisablePoints.cartCheckoutBtnID,this.toggleElements.subsMsgContainer,this.propsDisablePoints.hasSubsNote,this.propsDisablePoints.headerCheckoutBtnID].forEach((id)=>{hideElement(id);});
        } else {
          if (this.displayATC) { showElement(this.propsDisablePoints.addToCartBtn)} else { hideElement(this.propsDisablePoints.addToCartBtn); }
          this.verifySubInCart();
        }
      }
      //BMSM
      if (typeof(quickCartObj)!=='undefined'){
        if (typeof quickCartObj.displayPromoTotals==='function'){
          quickCartObj.displayPromoTotals(toggledView);
        }
      }
    }
  }
  verifySubInCart(): void{
    if (priceViewObj.propsDisablePoints.hasSubInCart){
      priceViewObj.propsDisablePoints.pointsTabContainerIDs.forEach((id) => {
        if (document.querySelector(id)){
          document.querySelector(id).classList.add(priceViewObj.propsDisablePoints.cssClass);
        }
      });
      priceViewObj.propsDisablePoints.ptSubtotalIDs.forEach((id) => {
        if ($(id)){
          $(id).html(priceViewObj.propsDisablePoints.subtotalCopy);
        }
      });
    }
  }
}
const priceViewObj = new PriceView(priceViewConfig);
jQuery(function () {
  priceViewObj.bindElementHandlers();
  priceViewObj.onLoadCheckPriceView();
});

interface PriceViewInterface {
  priceViewCookieName: string;
  currentPageName: string;
  cashViewPages: string[];
  pointsViewPages: string[];
  toggleElements: ToggleElements;
  currentView: string;
  pointsLogin: PointsLogin;
  enablePayByPoints: boolean;
  propsDisablePoints: PropsDisablePoints;
  pointsUnvailLightbox: DialogObj;
}

interface ToggleElements {
  toggleClass: string;
  toggleClassPoints: string;
  cashTabClass: string;
  pointsTabClass: string;
  checkboxName: string;
  subsContainer: string;
  subsMsgContainer: string;
  oneTimePurcContainer: string;
}
interface PointsLogin {
  btn_login_points: string;
  btn_logout_points: string;
  url: string;
}
interface PropsDisablePoints {
  hasSubInCart: boolean;
  pointsTabContainerIDs: string[];
  cssClass: string;
  ptSubtotalIDs: string[];
  cartCheckoutBtnID: string;
  subtotalCopy: string;
  addToCartBtn: string;
  atcPointsUnavailNote: string;
  lbPointsUnavailNote: string;
  div_lbCartBtns: string;
  hasSubsNote: string;
  headerCheckoutBtnID: string;
}